import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, User } from "lucide-react";

const CATEGORIES = [
  { name: "Hombre", path: "/categoria/hombre" },
  { name: "Mujer", path: "/categoria/mujer" },
  { name: "Accesorios", path: "/categoria/accesorios" },
  { name: "Gorras", path: "/categoria/gorras" },
  { name: "Zapatos", path: "/categoria/zapatos" },
];

const NAV_LINKS = [
  { name: "Inicio", path: "/" },
  ...CATEGORIES,
];

export const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      {/* Main Navbar */}
      <nav className="sticky top-0 z-50 bg-[#050505]/90 backdrop-blur-xl border-b border-white/5" data-testid="navbar">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-between h-14">
            {/* Hamburger - Left */}
            <button
              className="p-2 -ml-2 text-[#A0A0A0] hover:text-white transition-colors"
              onClick={() => setMobileMenuOpen(true)}
              aria-label="Menu"
              data-testid="mobile-menu-btn"
            >
              <Menu className="w-6 h-6" />
            </button>

            {/* Logo - Center */}
            <Link to="/" className="absolute left-1/2 -translate-x-1/2" data-testid="navbar-logo">
              <span className="font-oswald font-bold text-2xl tracking-tight">
                <span className="text-[#00FF66]">O</span>
                <span className="text-white">Y</span>
                <span className="text-[#B026FF]">B</span>
              </span>
            </Link>

            {/* Account - Right */}
            <Link
              to="/login"
              className="p-2 -mr-2 text-[#A0A0A0] hover:text-[#B026FF] transition-colors"
              data-testid="admin-nav-btn"
            >
              <User className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-[100] bg-[#050505]">
          <div className="flex items-center justify-between p-4 border-b border-white/5">
            <span className="font-oswald font-bold text-2xl">
              <span className="text-[#00FF66]">O</span>
              <span className="text-white">Y</span>
              <span className="text-[#B026FF]">B</span>
            </span>
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="p-2 text-white"
              data-testid="mobile-menu-close-btn"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <div className="p-4">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-4 text-lg border-b border-white/5 transition-colors ${
                  location.pathname === link.path
                    ? "text-[#00FF66] font-semibold"
                    : "text-[#A0A0A0] hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/referidos"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 text-lg text-[#00FF66] border-b border-white/5 font-semibold"
              data-testid="mobile-referral-link"
            >
              Comparte y Gana $50
            </Link>
            <Link
              to="/login"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 text-lg text-[#B026FF] border-b border-white/5"
              data-testid="mobile-admin-link"
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </>
  );
};
